<template>
  <div class="bingocard">
    <!-- <img id="scoretext" src="../assets/2025/koreanscore.png" /> -->
    <table class="card">
      <thead>
        <tr>
          <th scope="col">B</th>
          <th scope="col">I</th>
          <th scope="col">N</th>
          <th scope="col">G</th>
          <th scope="col">O</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in card" :key="`row-${index}`">
          <td v-for="(column, index2) in row" :key="`col-${index2}`" :class="[isTaken(column)?'taken':'', 'box-'+index+'-'+index2, isTakenFirst(column)?'taken-first':'']">
            {{ column }}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="stats">
      <p>{{ taken.length }} st - Bollar: 1p/st</p>
      <p class="taken-first">{{  takenFirst.length  }} st - Först på bollen: 1p/st</p>
      <p>{{ fullRows }} st - Rader: 5p/st</p>
      <p>{{ hasCorners }} st - Fyra hörn: 10p</p>
      <p>{{ extraPoints }} st - Extrapoäng 2p/st</p>
    </div>
    <h3>Total poäng - {{ score }} p</h3>
  </div>
</template>

<script>
export default {
  name: 'Bingocard',
  emits: ["start"],
  data() {
    return { 
/*      
      card: [
        [ 1, 5, 6, 9, 12 ],
        [ 16, 19, 21, 23, 27 ],
        [ 31, 32, 38, 40, 42 ],
        [ 48, 49, 54, 57, 58 ],
        [ 61, 69, 70, 71, 73 ]
      ],
      taken: [ 9, 19, 27, 38, 54, 58, 61, 48, 16, 31, 69, 1, 57, 49, 23, 12 ]
*/
    }
  },
  props: {
    card: Array,
    taken: Array,
    takenFirst: Array,
    extrapoints: Number,
  },
  methods: {
    isTaken(columnNum) {
      const num = Number(columnNum);
      return this.taken.includes(num);
    },
    isTakenFirst(columnNum) {
      const num = Number(columnNum);
// console.log('TF', this.takenFirst, columnNum);
// eslint-disable-next-line no-debugger
//debugger;
      return this.takenFirst.includes(num);
    },
    checkRow(rowNum) {
      for (let i = 0; i < 5; i++) {
        if (!this.taken.includes(this.card[rowNum][i])) return false;
      }
      return true;
    },
    checkColumn(colNum) {
      for (let i = 0; i < 5; i++) {
        if (!this.taken.includes(this.card[i][colNum])) return false;
      }
      return true;
    },
    checkDiagonalTL() {
      for (let i = 0; i < 5; i++) {
        if (!this.taken.includes(this.card[i][i])) return false;
      }
      return true;
    },
    checkDiagonalBL() {
      for (let i = 0; i < 5; i++) {
        if (!this.taken.includes(this.card[4-i][i])) return false;
      }
      return true;
    },
    checkCorners() {
      let corners = 0;
      if (this.taken.length == 0 || this.card.length == 0) return false; 
      if (this.taken.includes(this.card[0][0])) corners++;
      if (this.taken.includes(this.card[0][4])) corners++;
      if (this.taken.includes(this.card[4][0])) corners++;
      if (this.taken.includes(this.card[4][4])) corners++;

      return (corners == 4);
    }
  },
  computed: {
    hasCorners() {
      return this.checkCorners() ? 1 : 0;
    },
    fullRows() {
      let numRows = 0;
      if (!this.card || this.card.length < 5) return 0;

      for(let i=0; i<5; i++) {
        if (this.checkRow(i)) { numRows++ }
        if (this.checkColumn(i)) { numRows++ }
      }
      if (this.checkDiagonalBL()) { numRows++ }
      if (this.checkDiagonalTL()) { numRows++ }

      return numRows;
    },
    score() {
      return this.hasCorners*10 + this.fullRows*5 + this.taken.length + this.takenFirst.length + this.extrapoints*2;
    },
    extraPoints() {
      return this.extrapoints || 0;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.bingocard {
  padding-top: 1.5em;
  height: 100vh;
  background: var(--color-background);
  background: linear-gradient(180deg, #4e0f0a 80%, #290704 100%);
  background-size: contain;
}

#scoretext {
  position: absolute;
  top: 5em;
  left: 0;
  width: 100vw;
  height: auto;
  z-index: 10;
  pointer-events: none;
}

h1 {
  padding-top: 1em;
}
h2 {
  text-transform: uppercase;
  color: var(--color-red);
  margin: 1em 0;
}
.card {
  margin: 0px auto 0em;
  padding: 132px 39px 83px 34px;
  width: 360px;
//  min-height: 400px; 
  background: transparent url(../assets/2024/bingocard.png) no-repeat center top;
  background-size: contain;

  th {
    color: var(--color-background)
  }

  td {
    padding: 0.42em 0;
    text-align: center;
    font-size: 26px;
    font-weight: bolder;
    border-radius: 3px;
    color: var(--color-bingocard);
    font-family: var(--font-header);

        
    &.box-0-0,
    &.box-0-4,
    &.box-4-0,
    &.box-4-4 {
      background-color: var(--color-yellow);
      background: radial-gradient(circle, rgba(255, 228, 69, 0.6) 24%, rgba(255, 228, 69, 0) 80%);
//      background-color: rgba(255, 209, 0, 0.2); //var(--color-yellow-light); 
    }
    &.taken {
      border-radius: 50% 50%;
      padding: 1.1em 0.2em 0em 0;
      font-size: 14px;

      color: var(--color-background);
      background: url(../assets/2025/egg1.png) no-repeat center center;
//      background: url(../assets/2024/ball-yellow.png) no-repeat center center;
      background-size: contain;
      // background: radial-gradient(ellipse at 46% 46%, rgb(224 221 208 / 99%) 0%, rgba(255 255 255 / 80%) 37%, rgba(255,255,255,0) 38%), radial-gradient(ellipse farthest-corner at right bottom, var(--color-red) 0%, var(--color-red) 8%, transparent 80%), radial-gradient(ellipse farthest-corner at left top, #FFFFFF 0%, var(--color-red) 8%, var(--color-red) 25%, var(--color-red) 62.5%, var(--color-red) 100%);

    }

    &.taken-first {
//      background: radial-gradient(ellipse farthest-corner at right bottom, #FEDB37 0%, #FDB931 8%, #9f7928 30%, #8A6E2F 40%, transparent 80%), radial-gradient(ellipse farthest-corner at left top, #FFFFFF 0%, #FFFFAC 8%, #D1B464 25%, #5d4a1f 62.5%, #5d4a1f 100%);
      border-radius: 50% 50%;
      padding: 1.1em 0.2em 0em 0;
      font-size: 14px;

      color: var(--color-background);
      background: url(../assets/2025/eggfirst.png) no-repeat center center;
      // background: url(../assets/2024/ball-purple.png) no-repeat center center;
      background-size: contain;
    }
  }
}

h3 {
  position: absolute;
  top: 70px;
      width: 100vw;
    color: #000;
}

.stats {
    margin: 0 0em;
    padding: 0 4em;
    text-align: left;
    font-size: 0.75em;
    columns: 2;
    position: absolute;
    top: 100px;
    color: #000;
    width: 100vw;

  p {
    margin: 0.25em 0;
    font-size: 1em;

    &.taken-first {
      color: #af1915;
      // background: -webkit-linear-gradient(88deg, #86198E, #DE6BF5, #86198E);
      // background: -webkit-linear-gradient(#FEDB37, #FFFFAC, #9f7928);
      // -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
    }
  }
}
</style>
